'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _BackgroundCarousel = require('./BackgroundCarousel.scss');

var _BackgroundCarousel2 = _interopRequireDefault(_BackgroundCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SLIDE_DURATION = 12000;
var TRANSITION_ENTER_DURATION = 3000;
var TRANSITION_LEAVE_DURATION = 3000;

var BackgroundCarousel = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(BackgroundCarousel, _Component);

  function BackgroundCarousel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BackgroundCarousel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BackgroundCarousel.__proto__ || (0, _getPrototypeOf2.default)(BackgroundCarousel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      counter: 0
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BackgroundCarousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.interval = setInterval(function () {
        var next = _this2.state.counter + 1 < _this2.props.images.length ? _this2.state.counter + 1 : 0;
        _this2.setState({ counter: next });
      }, SLIDE_DURATION);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'getCarouselBackground',
    value: function getCarouselBackground() {
      var counter = this.state.counter;
      var currentImage = this.props.images[counter];
      var backgroundStyle = {
        backgroundImage: 'url(' + currentImage + ')'
      };
      return _react2.default.createElement('div', { key: 'carousel-background-' + counter, className: _BackgroundCarousel2.default.background, style: backgroundStyle });
    }
  }, {
    key: 'render',
    value: function render() {
      var carouselBackgroumDOM = this.getCarouselBackground();

      return _react2.default.createElement(
        'div',
        { className: _BackgroundCarousel2.default.backgroundCarousel },
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          {
            transitionName: _BackgroundCarousel2.default.background,
            transitionEnterTimeout: TRANSITION_ENTER_DURATION,
            transitionLeaveTimeout: TRANSITION_LEAVE_DURATION
          },
          carouselBackgroumDOM
        )
      );
    }
  }]);
  return BackgroundCarousel;
}(_react.Component), _class.propTypes = {
  images: _react.PropTypes.array.isRequired
}, _temp2);
exports.default = BackgroundCarousel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BackgroundCarousel/BackgroundCarousel.js
// module id = 1943
// module chunks = 0